import React, { Component } from 'react';
import './MyMapsAdvanced.css';
import MyMapsFooter from './MyMapsFooter.jsx';
import Collapsible from 'react-collapsible';
import Switch from 'react-switch';
import * as helpers from '../../../helpers/helpers';
import * as drawingHelpers from '../../../helpers/drawingHelpers';
import copy from 'copy-to-clipboard';

class MyMapsAdvanced extends Component {
  constructor(props) {
    super(props);

    this.inputId = 'fs-mymaps-advanced-import-input fs-editable';
    this.state = {
      open: false,
      editOn: false,
      editOption: 'vertices',
      inputText: '',
    };
  }

  onSwitchChange = (editOn) => {
    this.setState({ editOn });
    helpers.addAppStat('Edit Features Switch', 'Click');
    this.props.onEditFeatures(editOn, this.state.editOption);
  };

  onEditOption = (evt) => {
    this.setState({ editOption: evt.currentTarget.value });
    this.props.onEditFeatures(this.state.editOn, evt.currentTarget.value);
  };

  onImport = () => {
    // BASIC CHECKING
    if (this.state.inputText.length !== 36) {
      helpers.showMessage(
        'Učitavanje mapa',
        'ID nije validan.',
        helpers.messageColors.red
      );
      return;
    }

    drawingHelpers.importMyMaps(this.state.inputText, (result) => {
      if (result.error !== undefined)
        helpers.showMessage(
          'Učitavanje mapa',
          'ID nije pronađen!',
          helpers.messageColors.red
        );
      else {
        helpers.showMessage('Učitavanje mapa', 'Mape uspješno učitane.');
        this.props.onMyMapsImport(result);
      }
    });
  };

  onShare = () => {
    if (this.state.inputText.length !== 36) {
      helpers.showMessage(
        'Dijeljenje mapa',
        'ID nije validan.',
        helpers.messageColors.red
      );
      return;
    }
    let currentUrl = `${window.location.href.split('?')[0]}?MY_MAPS_ID=${
      this.state.inputText
    }`;
    copy(currentUrl);
    helpers.showMessage(
      'Dijeljenje mapa',
      'Link mapa spremljen u međuspremnik.',
      helpers.messageColors.green,
      5000
    );

    // APP STATS
    helpers.addAppStat('MyMaps', 'Share');
  };

  onSave = () => {
    if (!this.props.hasItems)
      helpers.showMessage(
        'Sačuvaj mape',
        'Nije moguće sačuvati mape! Elementi nisu pronađeni!',
        helpers.messageColors.yellow,
        5000
      );
    else {
      this.setState({ copied: true });
      drawingHelpers.exportMyMaps((result) => {
        helpers.showMessage(
          'Sačuvaj mape',
          'Mape su spremljene! ID je spremljen u međuspremnik.',
          helpers.messageColors.green,
          5000
        );
        helpers.glowContainer(this.inputId);
        this.setState({ inputText: result.id });
        copy(result.id);
      });
    }
    // APP STATS
    helpers.addAppStat('MyMaps', 'Save');
  };

  onInputChange = (evt) => {
    this.setState({ inputText: evt.target.value });
  };

  render() {
    return (
      <div id="fs-mymaps-advanced">
        <Collapsible trigger="Dodatne opcije" open={this.state.open}>
          <div className="fs-mymaps-advanced-content">
            <div className="fs-mymaps-advanced-import-container">
              <label className="fs-mymaps-advanced-main-label">
                Učitaj/Sačuvaj
              </label>
              <div>
                <input
                  className={this.inputId}
                  id={this.inputId}
                  type="text"
                  placeholder="Unesi ID mape"
                  onChange={this.onInputChange}
                  onFocus={(evt) => {
                    helpers.disableKeyboardEvents(true);
                  }}
                  onBlur={(evt) => {
                    helpers.disableKeyboardEvents(false);
                  }}
                  value={this.state.inputText}
                />
                <br />
                <button
                  className="fs-button fs-mymaps-advanced-import-button"
                  onClick={this.onImport}
                >
                  Učitaj
                </button>
                <button
                  className="fs-button fs-mymaps-advanced-import-button"
                  onClick={this.onSave}
                  disabled={!this.props.hasItems}
                >
                  Sačuvaj
                </button>
                <button
                  className="fs-button fs-mymaps-advanced-import-button"
                  onClick={this.onShare}
                >
                  Podijeli
                </button>
              </div>
            </div>
            <div className="fs-mymaps-advanced-edit-container">
              {/* <label className="fs-mymaps-advanced-main-label">Edit Features</label> */}
              <label
                className={
                  this.state.editOn
                    ? 'fs-mymaps-advanced-switch-label on'
                    : 'fs-mymaps-advanced-switch-label'
                }
              >
                Uređivanje elemenata
                <Switch
                  className="fs-mymaps-advanced-switch"
                  onChange={this.onSwitchChange}
                  checked={this.state.editOn}
                  height={20}
                  width={48}
                />
              </label>

              <div>
                <label style={{ marginRight: '15px' }}>
                  <input
                    className="fs-mymaps-advanced-edit-radio"
                    type="radio"
                    name="editOptions"
                    value="vertices"
                    defaultChecked={true}
                    onChange={this.onEditOption}
                  />
                  Vrh elementa
                </label>
                <label>
                  <input
                    className="fs-mymaps-advanced-edit-radio"
                    type="radio"
                    name="editOptions"
                    value="translate"
                    defaultChecked={false}
                    onChange={this.onEditOption}
                  />
                  Pomjeri element
                </label>
              </div>
            </div>

            <MyMapsFooter
              onMenuItemClick={this.props.onMenuItemClick}
              onDeleteAllClick={this.props.onDeleteAllClick}
            />
          </div>
        </Collapsible>
      </div>
    );
  }
}

export default MyMapsAdvanced;
